import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { typedMemo } from '@utils';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { BaseControllerProps } from './types';

interface SwitchFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends Omit<SwitchProps, 'name' | 'value' | 'onChange' | 'checked'>,
    BaseControllerProps<TFieldValues, TName> {
  label?: string;
}

const SwitchFormField = typedMemo(
  <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  >({
    name,
    control,
    rules,
    label,
    ...switchProps
  }: Readonly<SwitchFormFieldProps<TFieldValues, TName>>) => {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <Box>
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  {...switchProps}
                  checked={field.value || false}
                />
              }
              label={label}
            />
            {error && (
              <FormHelperText error sx={{ ml: 0 }}>
                {error.message}
              </FormHelperText>
            )}
          </Box>
        )}
      />
    );
  },
);
